module.exports = __webpack_public_path__ + "static/media/cheerio.f4069c8d.svg";